export default {"src":"/_next/static/media/clock_white.4eee8aa0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};